<div fxLayoutAlign.gt-sm="center center" fxLayout="column" class="consent-form-container">

    <mat-card class="card mat-elevation-z0">
        <mat-card-content>

            <div fxLayout="column" fxLayoutAlign="center center center">

                <div *ngIf="isLoading" fxFlex>
                    <app-loading></app-loading>
                </div>
                <div *ngIf="!isLoading"
                     ngStyle.gt-sm="width:65%;" ngStyle.lt-md="width:100%;"
                     fxFlex>
                    <!--      Back Button-->
                    <button (click)="navigateBack()" mat-icon-button class="back-button">
                        <mat-icon>arrow_back</mat-icon>
                    </button>

                    <!-- Modern Centered Header -->
                    <div class="form-header" fxLayout="column" fxLayoutAlign="center center">
                        <div class="header-icon">
                            <mat-icon>campaign</mat-icon>
                        </div>
                        <h1 class="form-title">{{formTitle}}</h1>
                        <div class="title-underline"></div>
                    </div>

                    <!--        Loading && Text Content -->
                    <div fxLayout="row" fxLayoutAlign="center center" #divElement ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width: 100%;" class="content-wrapper">
                        <div class="content-card">
                            <quill-editor readOnly="readOnly" [modules]="{ toolbar: false }"
                                          (onEditorCreated)="editorCreated($event, htmlContent)"
                                          [styles]="editorStylePreview"
                            ></quill-editor>
                        </div>
                        <app-loading *ngIf="isLoading"></app-loading>
                    </div>
                </div>

                <!--      Consents Context-->
                <div *ngIf="!isLoading && requiresConsent"
                     ngStyle.gt-sm="width:65%;" ngStyle.lt-md="width:100%;"
                     style="padding: 10px 20px 20px 10px; border: 1px solid #0000003b; border-radius: 4px;"
                     fxFlex>
                    <p><span class="paragraph"></span><strong>Συγκατάθεση:</strong>
                    </p>
                    <p><span class="paragraph"></span>Με τη συμπλήρωση των κατωτέρω πεδίων, συναινώ στην επεξεργασία των
                        δεδομένων
                        υγείας
                        μου που έχω καταχωρίσει
                        ανωτέρω, για τους σκοπούς που αναφέρονται στην ενημέρωση που συνοδεύει την παρούσα συγκατάθεση.
                    </p>
                    <div style="padding-left:30px;">
                        <div style="margin-top: 20px;padding-bottom: 10px;display: flex;
    flex-direction: column;
    align-items: center;">

                            <form class="example-form" fxLayout="column" *ngIf="!has_full_info">

                                <div fxLayout="row">
                                    <mat-form-field class="example-full-width">
                                        <label>
                                            <input matInput placeholder="Ονοματεπώνυμο χρήστη" readonly
                                                   [value]="getParentInfo('displayName')">
                                        </label>
                                    </mat-form-field>
                                </div>

                                <div fxLayout="row">
                                    <mat-form-field class="example-full-width">
                                        <label>
                                            <input matInput placeholder="Ονοματεπώνυμο" readonly
                                                   [value]="getChildInfo('displayName')">
                                        </label>
                                    </mat-form-field>
                                </div>

                                <div fxLayout="row">
                                    <mat-form-field class="example-full-width">
                                        <label>
                                            <input matInput placeholder="Έτος γέννησης" readonly
                                                   [value]="getChildInfo('birthday')">
                                        </label>
                                    </mat-form-field>
                                </div>

                            </form>

                            <form class="example-form" fxLayout="column" *ngIf="has_full_info">

                                <div fxLayout="row wrap" fxFlex="100" fxLayoutGap.lt-md="10px">

                                    <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                                        <mat-form-field>
                                            <label>
                                                <input matInput placeholder="Επώνυμο" readonly
                                                       [value]="getChildInfo('lastName')">
                                            </label>
                                        </mat-form-field>
                                    </div>

                                    <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                                        <mat-form-field>
                                            <label>
                                                <input matInput placeholder="Όνομα" readonly
                                                       [value]="getChildInfo('firstName')">
                                            </label>
                                        </mat-form-field>
                                    </div>

                                    <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                                        <mat-form-field>
                                            <label>
                                                <input matInput placeholder="Όνομα Πατέρα" readonly
                                                       [value]="getChildInfo('father_name')">
                                            </label>
                                        </mat-form-field>
                                    </div>

                                    <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                                        <mat-form-field>
                                            <label>
                                                <input matInput placeholder="Όνομα Μητέρας" readonly
                                                       [value]="getChildInfo('mother_name')">
                                            </label>
                                        </mat-form-field>
                                    </div>

                                    <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                                        <mat-form-field>
                                            <label>
                                                <input matInput placeholder="Τόπος Γέννησης" readonly
                                                       [value]="getChildInfo('place_of_birth')">
                                            </label>
                                        </mat-form-field>
                                    </div>

                                    <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                                        <mat-form-field>
                                            <label>
                                                <input matInput placeholder="Έτος Γέννησης" readonly
                                                       [value]="getChildInfo('birthday')">
                                            </label>
                                        </mat-form-field>
                                    </div>

                                    <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                                        <mat-form-field>
                                            <label>
                                                <input matInput placeholder="Τόπος Κατοικίας" readonly
                                                       [value]="getChildInfo('city')">
                                            </label>
                                        </mat-form-field>
                                    </div>

                                    <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                                        <mat-form-field>
                                            <label>
                                                <input matInput placeholder="Οδός" readonly
                                                       [value]="getChildInfo('street')">
                                            </label>
                                        </mat-form-field>
                                    </div>

                                    <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                                        <mat-form-field>
                                            <label>
                                                <input matInput placeholder="Ταχ. Κώδικας" readonly
                                                       [value]="getChildInfo('postal_code')">
                                            </label>
                                        </mat-form-field>
                                    </div>

                                    <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                                        <mat-form-field>
                                            <label>
                                                <input matInput placeholder="Αριθμός Ταυτότητας" readonly
                                                       [value]="getChildInfo('id_number')">
                                            </label>
                                        </mat-form-field>
                                    </div>

                                    <div fxFlex.md="25" fxFlex.lt-md="25" fxFlex.sm="100" fxFlex.gt-md="25">
                                        <mat-form-field>
                                            <label>
                                                <input matInput placeholder="Ημ. Εκδ. Ταυτότητας" readonly
                                                       [value]="getChildInfo('id_release_date')">
                                            </label>
                                        </mat-form-field>
                                    </div>

                                    <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                                        <mat-form-field>
                                            <label>
                                                <input matInput placeholder="Τηλέφωνο" readonly
                                                       [value]="getChildInfo('phone')">
                                            </label>
                                        </mat-form-field>
                                    </div>
                                </div>

                            </form>

                        </div>
                    </div>

                    <!--                  Consent Questions-->

                    <div style="margin-top: 20px;border-bottom: 1px solid #0000003b;padding-bottom: 10px;"
                         fxLayout="row" *ngFor="let item of consentQuestions">
                        <div fxFlex="98">
                            <span><strong>{{item.consentDescription}}</strong></span>
                        </div>
                        <div style="justify-content: center;">
                            <mat-slide-toggle class="example-margin" [checked]="item.consentValue"
                                              (change)="consentChange(item, $event)" disabled="false"
                                              color="primary">
                            </mat-slide-toggle>
                        </div>
                    </div>
                    <!---->


                </div>


                <!--              Two Factor -->
                <div *ngIf="mode === 'consent' && !showTwoFactor" fxLayout="row" fxLayoutAlign="center center"
                     class="actionsSection">
                    <button ngStyle.lt-md="width:100%;" fxFlex.lt-md="100" mat-flat-button (click)="submitConsent()"
                            style="color:white; background-color: var(--primary);">Ενημέρωση
                    </button>
                </div>

                <div *ngIf="showTwoFactor" ngStyle.gt-sm="width:65%;" ngStyle.lt-md="width:100%;"
                     fxFlex fxLayout="row"
                     style="height: 80px; background-color: whitesmoke; padding: 5px; margin-top: 5px;">
                    <div fxLayout="column" fxLayoutGap="5px">
            <span style="font-family: 'Century Gothic', sans-serif;">
              Πληκτρολογήστε τον 6ψήφιο κωδικό που σας έχει αποσταλεί
            </span>

                        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center center">
                            <mat-form-field appearance="legacy">
                                <mat-label>Κωδικός 2 βημάτων</mat-label>
                                <input matInput [(ngModel)]="code"/>
                            </mat-form-field>

                            <button mat-raised-button class="stepperButton" [disabled]="!code || code.length < 6"
                                    (click)="validateCode()">Επαλήθευση
                            </button>
                            <button [disabled]="!code || code.length < 6" (click)="requestCode()" mat-raised-button
                                    class="stepperButton">
                                Επαναποστολή κωδικού
                            </button>
                        </div>
                    </div>
                </div>
                <!--              -->
            </div>
        </mat-card-content>
    </mat-card>
    <ng-template #Loading>

    </ng-template>
</div>
